export interface ChatPageContext {
  route: string;
  path: string;
  app_id?: string;
  page_id?: string;
  entity_ids: Record<string, string>;
}

const UUID_RE = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

export function extractChatPageContext(url: string): ChatPageContext {
  const parsed = new URL(url, 'http://x');
  const path = parsed.pathname;
  const search = parsed.search;
  const route = path + search;

  let app_id: string | undefined;
  let page_id: string | undefined;

  const appsMatch = path.match(/^\/apps\/([^/]+)\/pages\/([^/]+)/);
  if (appsMatch) {
    app_id = appsMatch[1];
    page_id = appsMatch[2];
  } else {
    const segments = path.split('/').filter(Boolean);
    if (segments.length >= 2 && !UUID_RE.test(segments[0]) && !UUID_RE.test(segments[1])) {
      app_id = segments[0];
      page_id = segments[1];
    }
  }

  const entity_ids: Record<string, string> = {};
  parsed.searchParams.forEach((value, key) => {
    if (key === 'threadId') return;
    if (!value) return;
    if (key.endsWith('Id') || key.endsWith('ID')) {
      entity_ids[key] = value;
    }
  });

  return { route, path, app_id, page_id, entity_ids };
}
